// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ICertificationParticipatedIndustriesApi,
  ICertificationParticipatedIndustriesApiRequest,
  ICertificationParticipatedIndustriesApiGetAllAttrs,
  ICertificationParticipatedIndustriesApiGetAllResponse,
  ICertificationParticipatedIndustriesApiGetAttrs,
  ICertificationParticipatedIndustriesApiGetResponse,
  ICertificationParticipatedIndustriesApiSaveAttrs,
  ICertificationParticipatedIndustriesApiSaveResponse,
} from 'interfaces/back-office/content-management/certification/participated-industries/certification-participated-industries-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'
import { IBaseApiRequestPayload } from 'interfaces/api'

export class CertificationParticipatedIndustriesApi
  extends BaseApi<ICertificationParticipatedIndustriesApi>
  implements ICertificationParticipatedIndustriesApiRequest
{
  readonly url = ApiConstant.CONTENT_CERTIFICATION_PARTICIPATED_INDUSTRIES_URL
  private certificationParticipatedIndustriesUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get home welcomes
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationParticipatedIndustriesApiGetAllAttrs} payload
   *
   * @return {Promise<ICertificationParticipatedIndustriesApiGetAllResponse>} Promise<ICertificationParticipatedIndustriesApiGetAllResponse>
   */
  async certificationParticipatedIndustries_getCertificationParticipatedIndustries(
    payload: ICertificationParticipatedIndustriesApiGetAllAttrs,
  ): Promise<ICertificationParticipatedIndustriesApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.certificationParticipatedIndustriesUrl}/list`, payload.body, {
        ...payload.requestConfig,
      })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get home welcome
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationParticipatedIndustriesApiGetAttrs} payload
   *
   * @return {Promise<ICertificationParticipatedIndustriesApiGetResponse>} Promise<ICertificationParticipatedIndustriesApiGetResponse>
   */
  async certificationParticipatedIndustries_getCertificationParticipatedIndustry(
    payload: ICertificationParticipatedIndustriesApiGetAttrs,
  ): Promise<ICertificationParticipatedIndustriesApiGetResponse> {
    try {
      const response = await this.POST(
        `${this.certificationParticipatedIndustriesUrl}/${payload.params.id}`,
        {},
        { ...payload.requestConfig },
      )

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save home welcome
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationParticipatedIndustriesApiSaveAttrs} payload
   *
   * @return {Promise<ICertificationParticipatedIndustriesApiSaveResponse>} Promise<ICertificationParticipatedIndustriesApiSaveResponse>
   */
  async certificationParticipatedIndustries_saveCertificationParticipatedIndustry(
    payload: ICertificationParticipatedIndustriesApiSaveAttrs,
  ): Promise<ICertificationParticipatedIndustriesApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id
          ? `${this.certificationParticipatedIndustriesUrl}/update/${payload.params.id}`
          : `${this.certificationParticipatedIndustriesUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
